import React from "react";
import "../styles/SideBar.css";
import NewGeneration from "../components/NewGeneration";
import { GenerationProvider } from "../context/GenerationContext";

const GenerationProcess = () => {
  return (
    <GenerationProvider>
      <NewGeneration></NewGeneration>
    </GenerationProvider>
  );
};

export default GenerationProcess;
